import styled from 'styled-components'

export const QualityIndicatorsOverlayContent = styled.div`
  .overlay-indicator {
    display: flex;
    align-items: baseline;

    .overlay-indicator-rating {
      margin-left: 16px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
      flex-direction: column;
      margin-left: 0;
      margin-bottom: 16px;

      .overlay-indicator-rating {
        margin-left: 0;
      }
    }
  }

  .overlay-type {
    display: flex;
    margin-left: 22px;
    margin-bottom: 16px;

    .overlay-type-rating {
      min-width: 50px;
      margin-left: 60px;
    }
  }

  .overlay-rating-date {
    font-size: 14px;
    color: #6d767c;
    margin-bottom: 4px;
  }

  .overlay-table-head {
    display: flex;
    justify-content: space-between;
  }

  .overlay-table-head-divider {
    // width: 2px;
    border-top-width: 2px;
    border-top-color: black;
  }

  .overlay-table-row {
    display: flex;
    justify-content: space-between;
  }

  .overlay-table-count {
    width: 72px;
    min-width: 72px;
    margin-left: 16px;
  }
`
